/**
 * Avalara © 2019
 * file: engines/opus_ui/src/containers/EnvironmentContainer.jsx
 */

import React, { Component } from 'react';
import StatusItem from './StatusItem';
import envMappings from '../utils/envMappings';
import { connect } from 'react-redux';
import './EnvironmentContainer.css';

class EnvironmentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      env: this.props.env,
      title: envMappings[this.props.env].title,
    };
  }
  render() {
    return (
      <div className="environment">
        <div className="titleHolder">
          <h1 className="labelTitle">{this.state.title}</h1>
        </div>
        <StatusItem env={this.state.env} engine="account" />
        <StatusItem env={this.state.env} engine="auth" />
        <StatusItem env={this.state.env} engine="billing" />
        <StatusItem env={this.state.env} engine="bookings" />
        <StatusItem env={this.state.env} engine="business-activity" />
        <StatusItem env={this.state.env} engine="cpq" />
        <StatusItem env={this.state.env} engine="customer" />
        <StatusItem env={this.state.env} engine="default" />
        <StatusItem env={this.state.env} engine="delivery" />
        <StatusItem
          env={this.state.env}
          engine="event-notifications-publisher"
        />
        <StatusItem env={this.state.env} engine="legal" />
        <StatusItem env={this.state.env} engine="marketing" />
        <StatusItem env={this.state.env} engine="product" />
        <StatusItem env={this.state.env} engine="provisioning" />
        <StatusItem env={this.state.env} engine="usage" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(EnvironmentContainer);
